export default Object.freeze({
  Form: 'form',
  FormWizardStep: 'form-wizard-step',
  FormGroup: 'form-group',
  FormField: 'form-field',
  Action: 'action',
  ActionBehaviorCase: 'action-behavior-case',
  ActionCommandsBehaviorCase: 'action-commands-behavior-case',
  Variable: 'variable',
});
